import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";

const imageOptions = "?fm=jpg&fl=progressive&bg=rgb:fff";

function ImageGallery({
  images = [],
  selectedImageWidth = 485,
  thumbWidth = 70,
}) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const hasMultipleImages = images.length > 1;
  const selectedImage = images[selectedImageIndex];
  return (
    selectedImage && (
      <Gallery>
        <SelectedImage
          alt={selectedImage.name}
          src={`${selectedImage.image}${imageOptions}&w=${selectedImageWidth}`}
          srcSet={`${selectedImage.image}${imageOptions}&w=${
            selectedImageWidth * 2
          } 2x`}
          width={selectedImageWidth}
          height={selectedImageWidth}
        />
        {hasMultipleImages && (
          <Thumbs>
            {images.map((image, index) => (
              <Thumb
                key={`${image.name}-${index}`}
                onClick={() => setSelectedImageIndex(index)}
                selected={index === selectedImageIndex}
              >
                <img
                  src={`${image.image}${imageOptions}&w=${thumbWidth}`}
                  srcSet={`${image.image}${imageOptions}&w=${
                    thumbWidth * 2
                  } 2x`}
                  width={thumbWidth}
                  height={thumbWidth}
                  alt={image.name}
                />
              </Thumb>
            ))}
          </Thumbs>
        )}
      </Gallery>
    )
  );
}

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedImageWidth: PropTypes.number,
  thumbWidth: PropTypes.number,
};

export default ImageGallery;

const Gallery = styled.div`
  ${({ css }) => css && css};
`;

export const SelectedImage = styled.img`
  display: block;
  height: auto;
  border-radius: 5px;
`;
SelectedImage.displayName = "SelectedImage";

const Thumbs = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  grid-gap: 30px;
  img {
    width: 100%;
    height: auto;
    border-radius: 5px;
  }
`;

export const Thumb = styled.button`
  border: none;
  cursor: pointer;
  position: relative;
  padding: 0;
  background-color: ${color.white};
  border-radius: 5px;
  :after {
    content: "";
    transition: opacity 0.3s ease;
    display: block;
    background-color: ${color.white};
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 5px;
  }
  :focus:after,
  :hover:after {
    opacity: 0.4;
  }
  ${({ selected }) =>
    selected &&
    `
    box-shadow: 0px 0px 0px 2px ${color.mineShaft};
    :after {
      opacity: 0.4;
    }
  `};
`;
Thumb.displayName = "Thumb";
